var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "85%",
    viewBox: "0 0 213.49 128.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M332.43,251.27q0-19.47,0-38.94c0-5.52-3.07-8.62-8.63-8.63q-26.81,0-53.63,0c-5.49,0-8.68,3.16-8.69,8.65q0,38.81,0,77.62c0,5.54,3.15,8.54,8.7,8.54h53.64c5.59,0,8.6-3,8.6-8.56Q332.45,270.62,332.43,251.27ZM133.21,228.54h9.53V184.1H279v13.49h9.37c0-5.33,0-10.47,0-15.62,0-5.36-2.35-7.69-7.71-7.69H140.85c-5.36,0-7.63,2.3-7.64,7.68v46.58Zm122.21,29.79H162.5v18.32h92.92Zm-99.19,10.45c0-9.11,0-18.22,0-27.33,0-4.68-2.07-6.75-6.76-6.78-7.73,0-15.47-.07-23.2,0-4.68,0-6.7,2.18-6.7,6.84v54.13c0,4.83,2,6.86,6.9,6.87h22.43c5.57,0,7.34-1.79,7.34-7.45Q156.25,281.92,156.23,268.78Zm30.55,29c3.15,1.21,46,.93,47.57-.13a1.73,1.73,0,0,0-.15-.47,2.58,2.58,0,0,0-.66-.79c-4.58-2.63-6.2-6.85-6.33-11.85-.05-1.58-1.1-1.66-2.32-1.65-9.46,0-18.92,0-28.37,0-1.7,0-2.19.61-2.3,2.22-.28,4.44-1.48,8.46-5.76,10.84C187.85,296.25,187.47,297,186.78,297.76Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.43,251.27q0,19.34,0,38.68c0,5.57-3,8.56-8.6,8.56H270.19c-5.55,0-8.7-3-8.7-8.54q-.06-38.81,0-77.62c0-5.49,3.2-8.64,8.69-8.65q26.82,0,53.63,0c5.56,0,8.62,3.11,8.63,8.63Q332.45,231.8,332.43,251.27Zm-65.77-40.49v72.11h60.61V210.78Zm23.09,79.58a3.62,3.62,0,0,0-3.63-3.53,3.7,3.7,0,0,0-3.63,3.8,3.61,3.61,0,0,0,3.78,3.35A3.54,3.54,0,0,0,289.75,290.36Zm7.14-3.53a3.71,3.71,0,0,0-3.55,3.63,3.6,3.6,0,0,0,3.88,3.52,3.48,3.48,0,0,0,3.37-3.71A3.61,3.61,0,0,0,296.89,286.83Zm11,0a3.75,3.75,0,0,0-3.75,3.46,3.69,3.69,0,0,0,3.72,3.7,3.42,3.42,0,0,0,3.53-3.54A3.57,3.57,0,0,0,307.93,286.82Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,228.54V182c0-5.38,2.28-7.68,7.64-7.68H280.62c5.36,0,7.69,2.33,7.71,7.69,0,5.15,0,10.29,0,15.62H279V184.1H142.74v44.44Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.42,258.33v18.32H162.5V258.33Zm-44.58,13.31a4.53,4.53,0,0,0,4.06-4.22,4.2,4.2,0,0,0-4.4-4,4.11,4.11,0,0,0-3.88,4.24A4.36,4.36,0,0,0,210.84,271.64Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,268.78q0,13.14,0,26.29c0,5.66-1.77,7.45-7.34,7.45H126.46c-4.85,0-6.9-2-6.9-6.87V241.52c0-4.66,2-6.8,6.7-6.84,7.73-.08,15.47-.06,23.2,0,4.69,0,6.74,2.1,6.76,6.78C156.26,250.56,156.23,259.67,156.23,268.78Zm-3.84,22.46V246.57h-29v44.67Zm-14.12,2.27-1.1,0c-.68,1-1.92,2-1.87,3s1.49,1.69,2.32,2.53c.85-.89,2.2-1.68,2.39-2.69C140.16,295.53,138.9,294.46,138.27,293.51Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,297.76c.69-.78,1.07-1.51,1.68-1.85,4.28-2.38,5.48-6.4,5.76-10.84.11-1.61.6-2.24,2.3-2.22,9.45.06,18.91,0,28.37,0,1.22,0,2.27.07,2.32,1.65.13,5,1.75,9.22,6.33,11.85a2.58,2.58,0,0,1,.66.79,1.73,1.73,0,0,1,.15.47C232.82,298.69,189.93,299,186.78,297.76Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10,
      strokeWidth: "0.6158984899520874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.66,210.78h60.61v72.11H266.66Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,290.36a3.54,3.54,0,0,1-3.48,3.62,3.61,3.61,0,0,1-3.78-3.35,3.7,3.7,0,0,1,3.63-3.8A3.62,3.62,0,0,1,289.75,290.36Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,286.83a3.61,3.61,0,0,1,3.7,3.44,3.48,3.48,0,0,1-3.37,3.71,3.6,3.6,0,0,1-3.88-3.52A3.71,3.71,0,0,1,296.89,286.83Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.93,286.82a3.57,3.57,0,0,1,3.5,3.62A3.42,3.42,0,0,1,307.9,294a3.69,3.69,0,0,1-3.72-3.7A3.75,3.75,0,0,1,307.93,286.82Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.84,271.64a4.36,4.36,0,0,1-4.22-4,4.11,4.11,0,0,1,3.88-4.24,4.2,4.2,0,0,1,4.4,4A4.53,4.53,0,0,1,210.84,271.64Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.39,291.24h-29V246.57h29Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,293.51c.63.95,1.89,2,1.74,2.82-.19,1-1.54,1.8-2.39,2.69-.83-.84-2.28-1.65-2.32-2.53s1.19-2,1.87-3Z",
    transform: "translate(-119.25 -173.97)",
    style: {
      fill: "var(--primary)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.2853d178fa25abb2e2f11eae6ce71b59.svg";
export { ForwardRef as ReactComponent };